import { siteConfig } from "../config/site";

export default function About() {
  const { about, images } = siteConfig;
  return (
    <section id="about" data-testid="about-section" className="relative py-28 sm:py-36 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative">
          <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-[#FFDFD3]/40 to-[#B9E0FF]/40 blur-2xl" />
          <div className="relative aspect-[4/5] max-w-md rounded-[2rem] overflow-hidden shadow-[0_40px_70px_-30px_rgba(45,42,50,0.4)]">
            <img
              src={images.aboutPortrait}
              alt="Yicel"
              className="h-full w-full object-cover"
              data-testid="about-image"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="inline-block text-[0.7rem] tracking-[0.35em] uppercase text-[color:var(--yicel-violet)] font-semibold">
            Sobre mí
          </span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ink"
              data-testid="about-title">
            Sin máscaras.
            <br />
            <span className="text-gradient">Solo lo que siento.</span>
          </h2>

          <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-[color:var(--yicel-muted)] whitespace-pre-line"
             data-testid="about-bio">
            {about.bio}
          </p>

          <blockquote
            className="mt-8 pl-5 border-l-2 border-[color:var(--yicel-violet)]/60 font-display text-2xl sm:text-3xl italic text-ink max-w-xl"
            data-testid="about-quote"
          >
            “{about.quote}”
          </blockquote>
        </div>
      </div>
    </section>
  );
}
